import React, { Component } from 'react';
import anime from 'animejs';
import $ from 'jquery';
import Rodal from 'rodal';
import { panzoom } from 'jquery.panzoom';
import axios from 'axios';
// include styles
import 'rodal/lib/rodal.css';
import Waypoint from 'react-waypoint';
import * as Scroll from 'react-scroll';
import { Link, DirectLink, Element , Events, animateScroll as scroll, scrollSpy, scroller } from 'react-scroll';
import { Heading, Header, Slider, Section, MapsItems, FormRegister,
  MapDetail, Validate, Register } from './components/index';

import REQUEST, { formBody } from './api/requests';
import Page from './utils/animations';
import { pad } from './utils/_helpers';

const dataSource = require('./utils/data.js');
const configSource = require('./utils/config.js');

const defaultProps = {
  validatePos: 0,
  registerPos: 0,
  openNav: false,
  sidebar: false,
  mapDetailsData: {},
  loading: true,
  mounted: false,
  disableValidation: false,
  disableRegister: false,
  relatedData: {},
  relatedSuccess: false,
  maps: [],
}

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...defaultProps,
      mapsList: dataSource.data.pieces || [],
      menuList: configSource.data.menuList || [],
      hash: '',
    }

    this.stepsRegister = [
      { i: 1, key: 'choice', name: 'Choice', success: false, next: 2 },
      { i: 2, key: 'upload', name: 'Upload', success: false, back: 1, next: 3 },
      { i: 3, key: 'private', name: 'Private', success: false, back: 2, next: 4 },
      { i: 4, key: 'public', name: 'Public', success: false, back: 3, next: 5 },
      { i: 5, key: 'done', name: 'Done', success: false, next: 0, back: 4 },
    ];

    this.stepsValidate = [
      { i: 1, key: 'choice', name: 'Choice', success: false, next: 3 },
      { i: 2, key: 'upload', name: 'Upload', success: false, back: 2, next: 4, invisible: true },
      { i: 3, key: 'private', name: 'Private', success: false, back: 1, next: 4 },
      { i: 4, key: 'public', name: 'Public', success: false, back: 3, next: 5 },
      { i: 5, key: 'done', name: 'Done', success: false, next: 0, back: 4 },
    ];

    this.openData = this.openData.bind(this);
    this._navLinks = this._navLinks.bind(this);
    this.hookNav = this.hookNav.bind(this);
    this.closeDetails = this.closeDetails.bind(this);
    this.fetchMapDetails = this.fetchMapDetails.bind(this);
    this.onPressNumber = this.onPressNumber.bind(this);
    this.openDataWithPrint = this.openDataWithPrint.bind(this);
    this.verifyQr = this.verifyQr.bind(this);
    this.updateQR = this.updateQR.bind(this);
    this.scripts = this.scripts.bind(this);
    this.loader = this.loader.bind(this);
    this.disableValidation = this.disableValidation.bind(this);
    this.switchRegister = this.switchRegister.bind(this);
    this.resetValidate = this.resetValidate.bind(this);
    this.disableRegister = this.disableRegister.bind(this);
    this.resetAll = this.resetAll.bind(this);
    this.putDetailsIntoMap = this.putDetailsIntoMap.bind(this);
    this.getSaleDetails = this.getSaleDetails.bind(this);
    this._header = null;
    this._cancelTokenDetails = null;
    this._register = null;
    this._validate = null;
    this._cancelSaleDetails = null;
  }

  disableValidation(status) {
    this.setState({
      disableValidation: status || false,
    });
  }

  disableRegister(status) {
    this.setState({
      disableRegister: status || false,
    })
  }

  resetAll() {
    this.setState({
      ...this.state,
      disableValidation: false,
      disableRegister: false,
    }, () => {
      this._validate.reset();
      this._register.reset();
    });
  }

  resetValidate() {
    this.setState({
      relatedSuccess: false,
      relatedData: {},
    }, () => {
      this._validate.reset();
    });
  }

  switchRegister(response) {
    if (response) {
      this.setState({
        relatedSuccess: true,
      }, () => {
        this._register.acceptDataFromRelated(response);
      });
    }
  }

  scripts() {
    const that = this;
    let init = false;
    
    const getScrollTop = () => {
      const currentScrollTop = $(window).scrollTop();
      const h = window.innerHeight;
      if (currentScrollTop > h) {
        Page.sidebarIn();
      }
    }

    window.addEventListener('scroll', (event) => {
      if (!init) {
        init = true;
        getScrollTop();
      }
    }, false);

    $(document).ready(() => {
      $( window ).resize(function() {
        $('#body').removeClass('st-menu-open');
        var width = $(window).outerWidth();
        var h = window.innerHeight;
  
        if (width >= 991) {
          Page.sidebarClean();
          Page.headerClean();
          Page.headerInit();
          Page.sidebarInit();
          Page.headerIn();
        }
        setTimeout(() => {
          getScrollTop();
        });
        $('.slider').height(h);
      }).resize();
      setTimeout(() => {
        if (this.state.hash) {
          const scrollTop = $(this.state.hash).offset().top + 10;
          scroll.scrollTo(scrollTop);
        }
      }, 100);
    });
  }

  componentWillMount() {
    const checkLoaded = (maps) => {
      const loadedNumber = maps.filter(map => (map.large && map.small)).length;
      if (loadedNumber === maps.length) {
        setTimeout(() => {
          const hash = window.location.hash;
          this.setState({
            ...this.state,
            loading: false,
            hash,
          }, () => {
            this.scripts();
          });
        }, 100);
      }
    }

    let allMapImages = [];
    this.state.mapsList.forEach((map, i) => {
      allMapImages = [
        ...allMapImages, 
        { index: i, key: 'small', url: map.thumb }, 
        { index: i, key: 'large', url: map.url },
      ]
    });

    allMapImages.forEach((image, index) => {
      const src = image.url;
      const primaryImage = new Image();
      if (src) {
        primaryImage.onload = () => {
          const maps = [...this.state.mapsList];
          maps[image.index][image.key] = true;
          this.setState({
            maps,
          }, () => {
            checkLoaded.call(this, maps);
          });
        }
        primaryImage.onerror = () => {
          const maps = [...this.state.mapsList];
          maps[image.index][image.key] = true;
          this.setState({
            maps,
          }, () => {
            checkLoaded.call(this, maps);
          });
        };
        primaryImage.src = src;
      }
    });
  }

  // // fetch map details 
  fetchMapDetails(id, number) {
    const requesId = `${id}_N${pad(number)}`
    let cancel;
    const that = this;
    if (that._cancelTokenDetails) {
      that._cancelTokenDetails();
    }
    return REQUEST.fetchMapDetails(requesId, (cancel) => {
      that._cancelTokenDetails = cancel;
    })
      .then(function(response) {
        that.putDetailsIntoMap(response.data, number);
        return response;
      })
      .catch(err => { throw err; });
  }

  putDetailsIntoMap(response, number) {
    this._mapDetail.putData(response, number);
  }

  // get sale details 
  getSaleDetails() {
    let cancel;
    const that = this;
    if (that._cancelSaleDetails) {
      that._cancelSaleDetails();
    }
    return REQUEST.getSaleDetails((cancel) => {
      that._cancelSaleDetails = cancel;
    })
      .catch(err => { throw err; });
  }

  // verify image
  verifyQr(encodedJPG) {
    let cancel;
    const that = this;
    return REQUEST.verifyQR(encodedJPG, (cancel) => {
      that._cancelVerifyImage = cancel;
    })
      .then(function(response) {
        console.log('response ', response);
        return response;
      })
      .catch(err => { throw err; });
  }


  // verify image
  updateQR(data, update) {
    let cancel;
    const that = this;
    return REQUEST.updateQR(data, update, (cancel) => {
      that._cancelVerifyImage = cancel;
    })
      .then(function(response) {
        console.log('response ', response);
        return response;
      })
      .catch(err => { throw err; });
  }
  

  onPressNumber(id, number) {
    if (!id || !number) {
      throw 'Print identifiers are wrong';
      return;
    }
    this.fetchMapDetails(id, number);
  }

  closeDetails() {
    if (this._cancelTokenDetails) {
      this._cancelTokenDetails('fetching cancelled');
    }
  }

  openData(data) {
    this._mapDetail.show(data);
  }

  openDataWithPrint(data, printData) {
    return new Promise((resolve, reject) => {
      this._mapDetail.show(data, printData);
      resolve();
    })
  }

  _navLinks() {
    return this.state.menuList.map((li, i) => {
      return (
        <li key={i}>
        <Link 
          onSetActive={(to) => {}} 
          to={li.id} 
          spy={true} 
          ignoreCancelEvents={false}
          hashSpy={true}
          isDynamic={true}
          smooth={true}
          duration={500}
          className={`unline white`}
          href={li.id ? '#' + li.id : '#'}>{li.name ? li.name : ''}</Link></li>
      )
    });
  }

  _sliderWaypointEnter() {
    $('#body').removeClass('st-menu-open');
      var width = $(window).outerWidth();
      if (width <= 991) {} else {
        Page.sidebarClean();
        Page.headerClean();
        Page.sidebarOut().then(() => {
          Page.headerIn();
        });
      }
  }

  _sliderWaypointLeave() {
    Page.sidebarClean();
    Page.headerClean();

    Page.headerOut();
    this.sidebar = Page.sidebarIn();
  }

  toggleNav(e) {
    e.preventDefault();
    $('#body').toggleClass('st-menu-open');
  }

  hookNav(className) {
    if (this._header && typeof this._header.passHook === 'function') {
      this._header.passHook(className);
    }
  }

  loader() {
    return (
      <div className="loader-wrapper">
        <div className="preloader-container">
          <div className="preloader-loader" />
        </div>
      </div>
    )
  }
 
  render() {
    const navLinks = this._navLinks();

    if (this.state.loading) {
      return this.loader();
    }

    return (
      <div className={`body st-effect st-container`} id="body">
        <div className="st-container-helper">
        <Header
          ref={el => this._sidebar = el}
          toggleNav={this.toggleNav.bind(this)}
          type='sidebar'
          data={this.state.menuList}
          sidebar={this.state.sidebar}
          links={navLinks}
          hookNav={this.hookNav}
        />

        <div className="st-pusher">
          <Header
            ref={el => this._header = el}
            type='header'
            data={this.state.menuList}
            sidebar={this.state.sidebar}
            links={navLinks}
          />
          <main className="page-wrap st-content" id="page-wrap">
            <Waypoint
              topOffset={65}
              onEnter={this._sliderWaypointEnter.bind(this)}
              onLeave={this._sliderWaypointLeave.bind(this)}
            >
              <div className="slider" id="home">
                <Slider data={this.state.maps} openData={this.openData} />
              </div>
            </Waypoint>
            
            <Waypoint>
              <div className="st-content-inner">
                <div className="wrap" id="wrap">
                  <Section id="huibert-van-dorp" className="about flex-center">
                    <section className="row article_header">
                      <div className="col-lg-6">
                        <Heading title='Huibert Van Dorp' upTitle='About the artist' uppercase />
                      </div>
                    </section>
                    <section className="row article_content">
                      <div className="col-lg-6">
                        <p>Artist Huibert van Dorp, born in 149 in Leuven Belgium, started his education at the Royal Acadamy of Arts in The Hague because he was convinced he wanted to become a graphic designer.</p>
                        <p>He soon realizes that he had a passion for a more free form of expression, and chose to become an artist. He currently resides and works at his atelier in The Hague.</p>
                      </div>
                      <div className="col-lg-5 offset-lg-1">
                        <img src={require('./assets/huibert_van_dorp.jpg')} alt="Huibert Van Dorp" />
                      </div>
                    </section>
                  </Section>  


                  <Section id="about" className="maps flex-center">
                    <section className="row article_header">
                      <div className="col-lg-6">
                        <Heading title='About the maps' upTitle='Art project' uppercase />
                      </div>
                    </section>
                    <section className="row article_content">
                      <div className="col-lg-5 about_image-wrap">
                        <img src={require('./assets/hanjin_genoa.jpg')} alt="About the maps" />
                      </div>
                      <div className="col-lg-6 offset-lg-1 col-md-6">
                        <blockquote>
                          <p><i><span className="fas fa-quote-right"></span>Since my schooldays, I've been travellin' to my friends and collectors in the USA. Flying around in aeroplanes is not my favourite pastime... There are some container ships that will take passengers, great! I love the sea. The longer the trip the better. On board, I would work at the charts, fill in some stories about life at sea, how I drove the captain mad or trying to escape karaoke with the Filipinos</i></p>
                          <p><i>It's a different world, a small universe and the sheer size of the oceans has a humbling effect. Great trips they were and my maps are an homage to them.<span className="fas fa-quote-left"></span></i></p>
                        </blockquote>
                      </div>
                    </section>
                    <section className="maps_items">
                      <MapsItems data={this.state.maps} openData={this.openData}/>
                    </section>
                  </Section>


                  <Section id="certification" className="certification flex-center">
                    <section className="row article_header">
                      <div className="col-sm-12">
                        <Heading title='Certification' upTitle='Validate, Register or Update' uppercase />
                      </div>
                    </section>
                    <section className="row article_content">
                      <div className="col-lg-6 article_section">
                        <Validate 
                          data={this.state.maps}
                          formBody={formBody}
                          fetchMapDetails={this.fetchMapDetails}
                          openDataWithPrint={this.openDataWithPrint}
                          onVerifyQr={this.verifyQr}
                          switchRegister={this.switchRegister}
                          isDisableValidation={this.state.disableValidation}
                          onDisableRegister={this.disableRegister}
                          onResetAll={this.resetAll}
                          onPutDetails={this.putDetailsIntoMap}
                          ref={(ref) => { this._validate = ref; }}
                        />
                      </div>
                      <div className="col-lg-6 article_section">
                        <Register
                          data={this.state.maps}
                          onVerifyQr={this.verifyQr}
                          formBody={formBody}
                          onUpdateQR={this.updateQR}
                          stepsRegister={this.stepsRegister}
                          stepsValidate={this.stepsValidate}
                          onDisableValidation={this.disableValidation}
                          relatedData={this.state.relatedData}
                          relatedSuccess={this.state.relatedSuccess}
                          resetRelated={this.resetValidate}
                          isDisableRegister={this.state.disableRegister}
                          ref={(ref) => { this._register = ref; }}
                        />
                      </div>
                    </section>
                  </Section>
                </div>
              </div>
            </Waypoint>
            
            <footer id="contact" className="footer contacts">
                <article className="article container">
                  <section className="row article_header">
                    <div className="col-sm-12">
                      <Heading title='Contacts' upTitle='For more information' uppercase />
                    </div>
                  </section>
                  <section className="row article_content">
                    <div className="col-sm-6">
                      <p>&copy;&nbsp;Huibert van Dorp {new Date().getFullYear()}. All right reserved.</p>
                    </div>
                    <div className="col-sm-6 contact-info">
                      <p className="mail"><a className="unline dark" target="_blank" href="mailto:info@hvandorpprints.com">info@hvandorpprints.com</a></p>
                    </div>
                  </section>
                </article>
              </footer>
          </main>
        </div>

        </div>

        <MapDetail 
          ref={el => this._mapDetail = el }
          onPressNumber={this.onPressNumber}
          closeDetails={this.closeDetails}
          onGetSaleDetails={this.getSaleDetails}
        />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js